import React from "react";
import "../style/ProjectProgressionSkeleton.css";

interface Props {
    months?: number;
}

const ProjectProgressChartSkeleton: React.FC<Props> = ({ months = 2 }) => {
    // Match screenshot proportions (2024 vs 2025)
    const approvedHeights = [260, 70];
    const doneHeights = [230, 40];

    return (
        <div className="ppot-skeleton-wrapper">
            <div className="ppot-skeleton-card">

                {/* Header */}
                <div className="ppot-header">
                    <div className="ppot-filter ppot-shimmer" />
                    <div className="ppot-legend">
                        <div className="ppot-legend-item ppot-shimmer" />
                        <div className="ppot-legend-item ppot-shimmer" />
                        <div className="ppot-legend-item ppot-shimmer" />
                    </div>
                </div>

                {/* Chart */}
                <div className="ppot-chart-skel">

                    {/* Grid */}
                    <div className="ppot-grid-lines" />

                    {/* Line placeholder */}
                    <div className="ppot-line">
                        <svg width="100%" height="100%" preserveAspectRatio="none">
                            <path d="
                M 0 160
                L 100 120
              " />
                        </svg>
                    </div>

                    {/* Bars */}
                    <div className="ppot-bars">
                        {Array.from({ length: months }).map((_, i) => (
                            <div className="ppot-bar-group" key={i}>
                                <div
                                    className="ppot-bar approved ppot-shimmer"
                                    style={{ height: approvedHeights[i] }}
                                />
                                <div
                                    className="ppot-bar done ppot-shimmer"
                                    style={{ height: doneHeights[i] }}
                                />
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ProjectProgressChartSkeleton;
